// src/packages/chubb/travel/chubb_travel_student_2019/index.js
import TravelStudentCard from "./TravelStudentCard";
import TravelStudentDetails from "./TravelStudentDetails";
import "./travel_student.css";

/** Chubb — Travel Easy Overseas Student (Effective 01.08.2019) */
export default {
  id: "chubb_travel_student_2019",
  company: "ชับบ์ (Chubb)",        // ให้ตรงกับ COMPANY_INFO
  productLine: "travel",
  categories: ["student", "overseas", "travel"],
  nameTH: "Chubb Travel Easy — Overseas Student (S1–S3)",
  description:
    "แผนประกันเดินทางนักเรียนต่างประเทศ (Student 1–3): ค่ารักษาพยาบาล, เคลื่อนย้ายฉุกเฉิน, กระเป๋า, ดีเลย์ ฯลฯ",
  accent: "#0ea5e9",
  expiresAt: "9999-12-31",
  card: TravelStudentCard,
  detail: TravelStudentDetails,
  active: true,
};
